export const SET_INITIAL_STATE = 'CONFIGURATOR::SET_INITIAL_STATE';

export function setInitialState(state) {
    return {
        type: SET_INITIAL_STATE,
        state,
    };
}

export const SET_ACTIVE_COLOR = 'CONFIGURATOR::SET_ACTIVE_COLOR';

export function setActiveColor(activeColor) {
    return {
        type: SET_ACTIVE_COLOR,
        activeColor,
    };
}

export const SET_ACTIVE_MATERIAL = 'CONFIGURATOR::SET_ACTIVE_MATERIAL';

export function setActiveMaterial(activeMaterial) {
    return {
        type: SET_ACTIVE_MATERIAL,
        activeMaterial,
    };
}

export const SET_ACTIVE_PART = 'CONFIGURATOR::SET_ACTIVE_PART';

export function setActivePart(activePart) {
    return {
        type: SET_ACTIVE_PART,
        activePart,
    };
}

export const SET_TEMPLATE = 'CONFIGURATOR::SET_TEMPLATE';

export function setTemplate(template) {
    return {
        type: SET_TEMPLATE,
        template,
    };
}

export const SET_ACTIVE_MINE = 'CONFIGURATOR::SET_ACTIVE_MINE';

export function setActiveMine(activeMine) {
    return {
        type: SET_ACTIVE_MINE,
        activeMine,
    };
}

export const SET_ACTIVE_MINE_COLOR = 'CONFIGURATOR::SET_ACTIVE_MINE_COLOR';

export function setActiveMineColor(activeMineColor) {
    return {
        type: SET_ACTIVE_MINE_COLOR,
        activeMineColor,
    };
}

export const SET_ACTIVE_MENU_ITEM = 'CONFIGURATOR::SET_ACTIVE_MENU_ITEM';

export function setActiveMenuItem(activeMenuItem) {
    return {
        type: SET_ACTIVE_MENU_ITEM,
        activeMenuItem,
    };
}

export const SET_ACTIVE_AREA = 'CONFIGURATOR::SET_ACTIVE_AREA';

export function setActiveArea(activeArea) {
    return {
        type: SET_ACTIVE_AREA,
        activeArea,
    };
}

export const SET_ACTIVE_IMAGE = 'CONFIGURATOR::SET_ACTIVE_IMAGE';

export function setActiveImage(activeImage) {
    return {
        type: SET_ACTIVE_IMAGE,
        activeImage,
    };
}

export const SET_ACTIVE_TEXT = 'CONFIGURATOR::SET_ACTIVE_TEXT';

export function setActiveText(activeText) {
    return {
        type: SET_ACTIVE_TEXT,
        activeText,
    };
}

export const SET_MINE_COLOR = 'CONFIGURATOR::SET_MINE_COLOR';

export function setMineColor(mineColor) {
    return {
        type: SET_MINE_COLOR,
        mineColor,
    };
}

export const SET_IS_TEMPLATE_WARNING_POPUP_VISIBLE =
    'CONFIGURATOR::SET_IS_TEMPLATE_WARNING_POPUP_VISIBLE';

export function setIsTemplateWarningPopupVisible(isTemplateWarningPopupVisible) {
    return {
        type: SET_IS_TEMPLATE_WARNING_POPUP_VISIBLE,
        isTemplateWarningPopupVisible,
    };
}

export const TOGGLE_SHOULD_TEMPLATE_WARNING_POPUP_BE_DISABLED =
    'CONFIGURATOR::TOGGLE_SHOULD_TEMPLATE_WARNING_POPUP_BE_DISABLED';

export function toggleShouldTemplateWarningPopupBeDisabled() {
    return {
        type: TOGGLE_SHOULD_TEMPLATE_WARNING_POPUP_BE_DISABLED,
    };
}

export const DISABLE_TEMPLATE_WARNING_POPUP = 'CONFIGURATOR::DISABLE_TEMPLATE_WARNING_POPUP';

export function disableTemplateWarningPopup() {
    return {
        type: DISABLE_TEMPLATE_WARNING_POPUP,
    };
}

export const SET_IS_PRINTABLE_INFO_POPUP_VISIBLE =
    'CONFIGURATOR::SET_IS_PRINTABLE_INFO_POPUP_VISIBLE';

export function setIsPrintableInfoPopupVisible(isPrintableInfoPopupVisible) {
    return {
        type: SET_IS_PRINTABLE_INFO_POPUP_VISIBLE,
        isPrintableInfoPopupVisible,
    };
}

export const TOGGLE_SHOULD_PRINTABLE_INFO_POPUP_BE_DISABLED =
    'CONFIGURATOR::TOGGLE_SHOULD_PRINTABLE_INFO_POPUP_BE_DISABLED';

export function toggleShouldPrintableInfoPopupBeDisabled() {
    return {
        type: TOGGLE_SHOULD_PRINTABLE_INFO_POPUP_BE_DISABLED,
    };
}

export const DISABLE_PRINTABLE_INFO_POPUP = 'CONFIGURATOR::DISABLE_PRINTABLE_INFO_POPUP';

export function disablePrintableInfoPopup() {
    return {
        type: DISABLE_PRINTABLE_INFO_POPUP,
    };
}



export const SET_IS_LOADING = 'CONFIGURATOR::SET_IS_LOADING';

export function setIsLoading(isLoading) {
    return {
        type: SET_IS_LOADING,
        isLoading,
    };
}

export const SET_CUSTOMIZATION_TYPE = 'CONFIGURATOR::SET_CUSTOMIZATION_TYPE';

export function setCustomizationType(customizationType) {
    return {
        type: SET_CUSTOMIZATION_TYPE,
        customizationType,
    };
}

export const SET_CONFIG = 'CONFIGURATOR::SET_CONFIG';
export function setConfig(config) {
    return {
        type: SET_CONFIG,
        config,
    };
}

export const UNSET_ACTIVES = 'CONFIGURATOR::UNSET_ACTIVES';
export function unsetActives() {
    return {
        type: UNSET_ACTIVES,
    };
}

export const UNSET_PRINTABLE_AREA_ACTIVES = 'CONFIGURATOR::UNSET_PRINTABLE_AREA_ACTIVES';
export function unsetPrintableAreaActives() {
    return {
        type: UNSET_PRINTABLE_AREA_ACTIVES,
    };
}

export const OPEN_COLOR_PICKER = 'CONFIGURATOR::OPEN_COLOR_PICKER';

export function openColorPicker() {
    return {
        type: OPEN_COLOR_PICKER,
    };
}

export const CLOSE_COLOR_PICKER = 'CONFIGURATOR::CLOSE_COLOR_PICKER';

export function closeColorPicker() {
    return {
        type: CLOSE_COLOR_PICKER,
    };
}

export const OPEN_TEXT_EDITOR = 'CONFIGURATOR::OPEN_TEXT_EDITOR';

export function openTextEditor() {
    return {
        type: OPEN_TEXT_EDITOR,
    };
}

export const CLOSE_TEXT_EDITOR = 'CONFIGURATOR::CLOSE_TEXT_EDITOR';

export function closeTextEditor() {
    return {
        type: CLOSE_TEXT_EDITOR,
    };
}

export const SET_PEN_SHOTS = 'CONFIGURATOR::SET_PEN_SHOTS';

export function setPenShots(penShots) {
    return {
        type: SET_PEN_SHOTS,
        penShots,
    };
}

export const ADD_CUSTOM_COLOR = 'CONFIGURATOR::ADD_CUSTOM_COLOR';

export function addCustomColor(customColor) {
    return {
        type: ADD_CUSTOM_COLOR,
        customColor,
    };
}

export const ADD_CUSTOM_IMAGE = 'CONFIGURATOR::ADD_CUSTOM_IMAGE';

export function addCustomImage(customImage) {
    return {
        type: ADD_CUSTOM_IMAGE,
        customImage,
    };
}

export const ADD_CUSTOM_TEXT = 'CONFIGURATOR::ADD_CUSTOM_TEXT';

export function addCustomText(customText) {
    return {
        type: ADD_CUSTOM_TEXT,
        customText,
    };
}

export const REMOVE_CUSTOM_TEXT = 'CONFIGURATOR::REMOVE_CUSTOM_TEXT';

export function removeCustomText(customText) {
    return {
        type: REMOVE_CUSTOM_TEXT,
        customText,
    };
}

export const REMOVE_CUSTOM_IMAGE = 'CONFIGURATOR::REMOVE_CUSTOM_IMAGE';

export function removeCustomImage(customImage) {
    return {
        type: REMOVE_CUSTOM_IMAGE,
        customImage,
    };
}

export const FETCH_PEN_DATA = 'CONFIGURATOR::FETCH_PEN_DATA';

export function fetchPenData() {
    return {
        type: FETCH_PEN_DATA,
    };
}

export const SET_MIN_ORDER_AMOUNT = 'CONFIGURATOR::SET_MIN_ORDER_AMOUNT';
export function setMinOrderAmount(minOrderAmount) {
    return {
        type: SET_MIN_ORDER_AMOUNT,
        minOrderAmount,
    };
}

export const SHOW_NOTIFICATION = 'CONFIGURATOR::SHOW_NOTIFICATION';

export function showNotification() {
    return {
        type: SHOW_NOTIFICATION,
    };
}

export const HIDE_NOTIFICATION = 'CONFIGURATOR::HIDE_NOTIFICATION';
export function hideNotification() {
    return {
        type: HIDE_NOTIFICATION,
    };
}

export const SET_PART_MATERIAL_AND_COLOR = 'CONFIGURATOR::SET_PART_MATERIAL_AND_COLOR';

export function setPartMaterialAndColor(part, material, color) {
    return {
        type: SET_PART_MATERIAL_AND_COLOR,
        part,
        material,
        color,
    };
}

export const OPEN_NOTICE_POPUP = 'CONFIGURATOR::OPEN_NOTICE_POPUP';

export function openNoticePopup() {
    return {
        type: OPEN_NOTICE_POPUP,
    };
}

export const CLOSE_NOTICE_POPUP = 'CONFIGURATOR::CLOSE_NOTICE_POPUP';

export function closeNoticePopup() {
    return {
        type: CLOSE_NOTICE_POPUP,
    };
}

export const SET_NOTICE_POPUP_CONTENT = 'CONFIGURATOR::SET_NOTICE_POPUP_CONTENT';

export function setNoticePopupContent(title, text, buttonLabel) {
    return {
        type: SET_NOTICE_POPUP_CONTENT,
        title,
        text,
        buttonLabel,
    };
}
